import { Routes, Route, Navigate } from 'react-router-dom';

import SignUp from './Auth/SignUp';
import SignIn from './Auth/SignIn';
import VerifyEmail from './Auth/VerifyEmail';
import ResetLink from './Auth/ResetLink';
import ConfirmEmail from './Auth/ConfirmEmail';
import ResetPassword from './Auth/ResetPassword';

import BasePage from './BasePage';
import SensorsPage from './Dashboard/SensorsPage.jsx';
import SensorPage from './Dashboard/SensorPage.jsx';
import NoMatch from './NoMatch';
import ProfilePage from './ProfilePage.jsx';
import CropsPage from './CropsPage.jsx';
import MapPage from './MapPage.jsx';
import ScoringPage from './ScoringPage.jsx';
import FieldsPage from './FieldsPage.jsx';
import SeasonPage from './SeasonPage.jsx';
import SoilSensorPage from './SoilSensorPage.jsx';
import LocationsPage from './LocationsPage.jsx';
import MembersPage from './MembersPage.jsx';
import NavigatorPage from './NavigatorPage.jsx';

import { Devices } from '../components/Devices/index.jsx';
import { AuthTemplate } from '../components/AuthTemplate/index.jsx';
// import OpenAppPage from './OpenApp/OpenAppPage.jsx';

const Main = () => {
  return (
    <Routes>
      {/*<Route path="open-app" element={<OpenAppPage />}/>*/}
      <Route path="login" element={<AuthTemplate type="login" />}>
        <Route index element={<SignIn />} />
      </Route>
      <Route path="login" element={<AuthTemplate type="reset" />}>
        <Route path="verify" element={<VerifyEmail />} />
        <Route path="reset" element={<ResetLink />} />
      </Route>
      <Route path="signup" element={<AuthTemplate type="signup" />}>
        <Route index element={<SignUp />} />
        <Route path="confirm" element={<ConfirmEmail />} />
      </Route>
      <Route path="reset-password" element={<AuthTemplate type="signup" />}>
        <Route index element={<ResetPassword />} />
      </Route>
      <Route path="/" element={<BasePage />}>
        <Route path="sensors" element={<SensorsPage />} />
        <Route path="timeline">
          <Route index element={<Navigate to="/sensors" replace />} />
          <Route path=":id" element={<SensorPage type="timeline" />} />
        </Route>
        <Route path="charts">
          <Route index element={<Navigate to="/sensors" replace />} />
          <Route path=":id" element={<SensorPage type="charts" />} />
        </Route>
        <Route path="photo">
          <Route index element={<Navigate to="/sensors" replace />} />
          <Route path=":id" element={<SensorPage type="photo" />} />
        </Route>
        <Route path="charts-soil">
          <Route index element={<Navigate to="/sensors" replace />} />
          <Route path=":id" element={<SensorPage type="charts-soil" />} />
        </Route>
        <Route path="vegetation">
          <Route index element={<Navigate to="/sensors" replace />} />
          <Route path=":id" element={<SensorPage type="vegetation" />} />
        </Route>
        <Route path="map" element={<MapPage />} />
        <Route path="navigator" element={<NavigatorPage />} />
        <Route path="crops" element={<CropsPage />} />
        <Route path="scoring" element={<ScoringPage />} />
        <Route path="members">
          <Route index element={<MembersPage />} />
        </Route>
        <Route path="devices">
          <Route index element={<Devices type="table" />} />
          <Route path=":id" element={<LocationsPage />} />
        </Route>
        <Route path="devices-diagram">
          <Route index element={<Devices type="diagram" />} />
        </Route>
        <Route path="profile">
          <Route index element={<ProfilePage type="profile" />} />
        </Route>
        <Route path="workspaces">
          <Route index element={<ProfilePage type="workspaces" />} />
        </Route>
        <Route path="fields" element={<FieldsPage />}></Route>
        <Route path="season" element={<SeasonPage />}></Route>
        <Route path="soil-sensor" element={<SoilSensorPage />}></Route>
      </Route>
      {/*<Route path="error" element={<ErrorPage />} />*/}
      {/*<Route path="empty" element={<EmptyPage />}></Route>*/}
      <Route path="*" element={<NoMatch />} />
    </Routes>
  );
};

export default Main;
